import React from 'react';

import { api } from '../../../api';
import { isImageUrl } from '../../../util/url';

const GlobalInfobar = () => {
  const { data: personalizationContent, isLoading: personalizationContentLoading } =
    api.personalization.personalizationContent.useQuery();

  if (
    personalizationContentLoading ||
    !personalizationContent?.infobar?.enabled ||
    !personalizationContent.infobar.message?.trim()
  ) {
    return null;
  }

  const iconUrl = personalizationContent.infobar.iconUrl?.trim();
  const showIcon = Boolean(iconUrl && isImageUrl(iconUrl));

  return (
    <div className="container" aria-label="Banner" role="banner">
      <div className="mx-auto flex flex-col rounded-xl border border-orange-300 bg-white px-6 py-5 md:flex-row">
        <div className="flex items-start">
          {showIcon ? <img className="message-icon mr-3 h-6 w-6 shrink-0" src={iconUrl} alt="" /> : null}
          <p className="font-[Poppins] font-semibold">{personalizationContent.infobar.message}</p>
        </div>
      </div>
    </div>
  );
};

export default GlobalInfobar;
